export const REFERRAL_MIN_TOKENS_PER_MONTH = 100;
export const REFERRAL_GRACE_MONTHS = 3;

export function getReferralEligibilityCopy(state) {
  const tokens = Number(state?.tokensThisMonth ?? 0);
  const min = Number(state?.minTokensRequired ?? REFERRAL_MIN_TOKENS_PER_MONTH);
  const remaining = Number(state?.tokensRemaining ?? Math.max(0, min - tokens));
  const graceEnds = state?.graceEndsAt ? new Date(state.graceEndsAt).toLocaleDateString() : '';

  switch (state?.messageKey) {
    case 'unverified':
      return {
        pill: 'Verify email',
        tooltip: 'Verify your email to unlock referral rewards and start your grace period.',
        banner: null,
      };
    case 'grace_active':
      return {
        pill: 'New member',
        tooltip: graceEnds ? `No monthly token target until ${graceEnds}.` : 'New member grace period active.',
        banner: null,
      };
    case 'grace_ending_soon':
      return {
        pill: 'New member',
        tooltip: graceEnds ? `From ${graceEnds}, earn ${min} tokens each month to keep referral rewards.` : '',
        banner: graceEnds
          ? `From ${graceEnds}, earn ${min} tokens each month to keep referral rewards.`
          : null,
      };
    case 'referral_target_met':
      return {
        pill: `${tokens >= min ? `${min}+` : tokens} tokens`,
        tooltip: 'Referral rewards unlocked this month.',
        banner: null,
      };
    default:
      return {
        pill: `${tokens} / ${min} tokens`,
        tooltip: `Earn ${remaining} more tokens this month to keep referral rewards from your community.`,
        banner: null,
      };
  }
}
